import { HotelPreview, ResultsContainer } from './../../../modules/results/results.container';
import { Router } from '@angular/router';

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { Hotelier } from '../../../core/models/results/offer.model';

@Component({
    selector: 'app-hotel-preview',
    templateUrl: 'hotel-preview.component.html',
    styleUrls: ['hotel-preview.component.css', 'hotel-preview.component.scss']
})

export class HotelPreviewComponent implements OnInit {

    @Input() hotelPreviewInfo: HotelPreview;
    @Input() selectedExps: Map<Number, String>;
    @Input() isOffer: boolean;
    @Input() days;
    @Output() receiveRequest: EventEmitter<any> = new EventEmitter();
    @Output() receiveRequestCounter: EventEmitter<any> = new EventEmitter();
    public show = false;
    public checked = false;
    appLogo = '../../../../assets/img/icons/vervendo-icon.svg';
    finalWishes: Map<String, Boolean>;
    totalWishes: number;
    satWishes: number;
    constructor(protected router: Router, public resultsContainer: ResultsContainer, private angulartics2: Angulartics2) { }

    ngOnInit() {
        this.totalWishes = 0;
        this.satWishes = 0;
        if (this.isOffer) {

            if (this.hotelPreviewInfo.hotelier === null) {
                const hotelier: Hotelier = {
                    name: this.hotelPreviewInfo.hotelierName.toString(),
                    surname: '',
                    picture: '',
                    title: ''
                };
                this.hotelPreviewInfo.hotelier = hotelier;
            }

            const selected = new Map<Number, String>();
            this.selectedExps.forEach((value: String, key: Number) => {
                selected.set(key, value);
                this.totalWishes++;
            });

            this.finalWishes = new Map<String, Boolean>();
            const split = this.hotelPreviewInfo.wishesSatisfied.split(',');
            if (split.length > 0) {
                for (let i = 0; i < split.length; i++) {
                    selected.forEach((value: String, key: Number) => {
                        if (parseInt(split[i], 10) === key) {
                            this.finalWishes.set(value, true);
                            this.satWishes++;
                            selected.delete(key);
                        }
                    });
                }
                selected.forEach((value: String, key: Number) => {
                    this.finalWishes.set(value, false);
                });
            }
        }
    }

    toggleExperiences() {
        this.show = !this.show;
    }

    angulartics2Track(action: string) {
        this.angulartics2.eventTrack.next({ action: action });
    }

    getStars = (stars) => Array(stars).fill(1);

    getrouterUrl = () => this.router.url;

    getDiscount(offerPrice, price) {
        return Math.floor(100 * (price - offerPrice) / price);
    }

    getOverPrice(offerPrice, price) {
        const discount = ((price - offerPrice) / price) * 100;
        return discount * (-1);
    }

    hasRoomDiscount(price, offerPrice) {
        if (price > offerPrice) {
            return true;
        } else {
            return false;
        }
    }

    sendCheckedtoParent(id: any) {
        console.log(id);
        if (id) {
            this.receiveRequest.emit(id);
            this.receiveRequestCounter.emit();
            const btnElement = <HTMLInputElement>document.getElementById(id);
            if (btnElement.classList.contains('requestBtnClicked')) {
                btnElement.classList.remove('requestBtnClicked');
            } else {
                btnElement.classList.add('requestBtnClicked');
            }
        }
    }
    hasTick(experience) {
        // console.log(experience);
        const item = this.hotelPreviewInfo.requestInfo.opthotelroomfacilities
            .find(facility => facility.facility.name === experience.title);
        if (item) { return true; }
        return false;
    }

    isTablet() {
        const w = window.innerWidth;
        if (w < 1200) {
            return true;
        }
        return false;
    }

    // f this listener will load the current image and the next when clicked in the carousel
    onSlide({ prev, current, direction }) {
        //        console.log('slideChange: ' + current);
        if (this.hotelPreviewInfo.pictures[current]) {
            this.hotelPreviewInfo.pictures[current].preloaded = true;
        }
        if (this.hotelPreviewInfo.pictures[current + 1]) {
            this.hotelPreviewInfo.pictures[current + 1].preloaded = true;
        }
    }

    isSmallLaptop() {
        const w = window.innerWidth;
        if (w < 1300) {
            return true;
        }
        return false;
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }
        return false;
    }

    isMobileSmall() {
        const w = window.innerWidth;
        if (w >= 360 && w < 450) {
            return true;
        }

        return false;
    }
}

